import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { hasAccessTo } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/helper/has-access-to';
import { ActionsByResource } from '@delmonicos/shared-sdk/libs/cpms/src/libs/identity-service-lib/src/wrapper/enums/action.enum';
import { Resource } from '@delmonicos/shared-sdk/libs/cpms/src/libs/identity-service-lib/src/wrapper/enums/resource.enum';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { permissions } from '@app/core/authentication/authentication.slice';
import { useAppSelector } from '@app/core/hooks';

import { EnergyCard } from './energy/energy.card';
import { RevenueCard } from './revenue/revenue.card';
import * as css from './statistics.module.scss';
import { TransactionsCard } from './transactions/transactions.card';

export const StatisticsComponent = (): React.JSX.Element => {
  const { t } = useTranslation();

  // USER PERMISSIONS //////////////////////////////////////////////////////////

  const userPermissions = useAppSelector(permissions);

  const hasAccessToTransaction = useMemo(
    () =>
      userPermissions &&
      hasAccessTo(userPermissions, {
        resourceName: Resource.STATISTICS_SESSIONS_INFO,
        action: ActionsByResource.STATISTICS_SESSIONS_INFO.READ,
      }),
    [userPermissions],
  );

  const hasAccessToEnergy = useMemo(
    () =>
      userPermissions &&
      hasAccessTo(userPermissions, {
        resourceName: Resource.STATISTICS_ENERGY,
        action: ActionsByResource.STATISTICS_ENERGY.READ,
      }),
    [userPermissions],
  );

  const hasAccessToRevenue = useMemo(
    () =>
      userPermissions &&
      hasAccessTo(userPermissions, {
        resourceName: Resource.STATISTICS_REVENUE,
        action: ActionsByResource.STATISTICS_REVENUE.READ,
      }),
    [userPermissions],
  );

  // RENDER ////////////////////////////////////////////////////////////////////

  if (!hasAccessToRevenue && !hasAccessToTransaction && !hasAccessToEnergy) {
    return <div />;
  }

  return (
    <div className={css.statisticsContainer}>
      <div className={css.legend}>
        <div />
        <Text>{t('$.dashboard.statistics.legend.previous-month')}</Text>
        <Text>{t('$.dashboard.statistics.legend.current-month')}</Text>
        <Text>{t('$.dashboard.statistics.legend.forecast')}</Text>
      </div>
      {hasAccessToTransaction && <TransactionsCard />}
      {hasAccessToEnergy && <EnergyCard />}
      {hasAccessToRevenue && <RevenueCard />}
    </div>
  );
};
